import React, { useContext, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { NewRequestContext } from '../../context/NewRequestContext';
import { defaultDevice } from '../../utils/Enums/NewRequest';
import { NewRequestDevice } from './NewRequestDevice';
import { useTranslation } from 'react-i18next';
import { Controller, useForm } from 'react-hook-form';
import { NewRequestMaterialsTable } from '../Dashboard/NewRequestMaterialsTable';
import { MaterialBranch } from '../../models/dashboard-models';
import {NoDataComponent} from "../NoDataComponent";

export const NewRequestBranchDevices = () => {
    const { t } = useTranslation('translation', { keyPrefix: 'common' });
    const { selectedBranch, devices, materials, getMaterials, resourcesLoadFailed } = useContext(NewRequestContext);
    const [showNewDeviceTemplate, setShowNewDeviceTemplate] = useState(false);

    const {
        control,
    } = useForm<MaterialBranch[]>({
        defaultValues: materials,
    });


  

    return (
        <div className='d-flex flex-column align-items-center p-3 pt-0  new-request-device'>
            <h5 className='w-100 text-center border-bottom pb-2'>{t('devices')}</h5>
            {!devices && selectedBranch.id && !resourcesLoadFailed ? (
                <div className='py-4'><Spinner animation='border' role='status' /></div>
            ) : devices && devices?.items.length>0 && selectedBranch.id ? (
                devices.items.map((device, index) => (
                    <NewRequestDevice device={device} key={index} setShowDeviceTemplate={setShowNewDeviceTemplate} />
                ))
            ) : (<div className={'pb-3'}>
                    <NoDataComponent noDataText={t('devices')} />
                </div>)}
            {showNewDeviceTemplate && selectedBranch.id && (
                <NewRequestDevice
                    device={defaultDevice}
                    isCreatingNew={true}
                    setShowDeviceTemplate={setShowNewDeviceTemplate}
                />
            )}

            <h5 className='w-100 text-center border-bottom pb-2'>{t('materials')}</h5>
            {!materials && selectedBranch.id && !resourcesLoadFailed ? (
                <div className='py-4'><Spinner animation='border' role='status' /></div>
            ) : (
            <Controller
                control={control}
                name={`${1}.id`}
                render={({ field }) => (
                <NewRequestMaterialsTable
                    onChange={(value) => field.onChange(value)}
                    materials={materials ?? []}
                    isDashboard={true}
                    isDisabled={true}
                    selectedBranch={selectedBranch}
                    refetchMaterials={getMaterials}
                />
                )}
            />
            )}
        </div>
    );
};
